import { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { MessageSquare } from "lucide-react";
import { useEnquiry } from "@/components/site/EnquiryContext";
import { MenuPanel } from "@/components/site/MenuPanel";

const LABELS = { "/residential": "Residential", "/commercial": "Commercial" };

export const Header = () => {
  const { pathname } = useLocation();
  const label = LABELS[pathname];
  return (
    <header className="site-header fixed inset-x-0 top-0 z-50" data-testid="site-header">
      <div className="mx-auto flex h-[68px] max-w-[1440px] items-center justify-between px-5 md:h-[76px] md:px-8">
        <div className="flex min-w-0 items-center gap-4">
          <Link to="/" onClick={(e) => { if (pathname === "/") { e.preventDefault(); if (window.location.hash) window.history.replaceState(null, "", "/"); window.scrollTo({ top: 0, behavior: window.matchMedia("(prefers-reduced-motion: reduce)").matches ? "auto" : "smooth" }); } }} className="block shrink-0 rounded-sm focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-4 focus-visible:outline-white" aria-label="ALUMICOM Architectural Aluminum Products, home" data-testid="header-logo-link">
            <img src="/img/logo-white-600.png" alt="" width="600" height="119" className="header-logo" data-testid="header-logo-img" />
          </Link>
          {label && (
            <span className="flex items-center gap-4 text-sm font-semibold text-white" data-testid="header-page-label">
              <span className="h-6 w-px bg-white/35" aria-hidden="true" />{label}
            </span>
          )}
        </div>
        <MenuPanel />
      </div>
    </header>
  );
};

export const FloatingContact = () => {
  const { openEnquiry, open } = useEnquiry();
  const [show, setShow] = useState(false);
  useEffect(() => {
    const onScroll = () => setShow(window.scrollY > 240);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);
  return (
    <button
      type="button"
      onClick={() => openEnquiry("Floating Contact us button")}
      className={`floating-contact btn-glass btn-on-dark ${show && !open ? "is-visible" : ""}`}
      aria-hidden={!show}
      tabIndex={show ? 0 : -1}
      data-testid="floating-contact-btn"
    >
      <MessageSquare aria-hidden="true" size={16} /> Contact us
    </button>
  );
};

export const ScrollManager = () => {
  const { pathname, hash } = useLocation();
  useEffect(() => {
    if (!hash) { window.scrollTo(0, 0); return undefined; }
    let tries = 0;
    let t;
    const go = () => {
      const el = document.getElementById(hash.slice(1));
      if (el) el.scrollIntoView({ block: "start" });
      else if (tries++ < 20) t = setTimeout(go, 60);
    };
    t = setTimeout(go, 30);
    return () => clearTimeout(t);
  }, [pathname, hash]);
  return null;
};
